import { render, staticRenderFns } from "./OrthoOnsetDate.vue?vue&type=template&id=55fcfd32&scoped=true"
import script from "./OrthoOnsetDate.vue?vue&type=script&lang=js"
export * from "./OrthoOnsetDate.vue?vue&type=script&lang=js"
import style0 from "./OrthoOnsetDate.vue?vue&type=style&index=0&id=55fcfd32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fcfd32",
  null
  
)

export default component.exports